import { useState, useEffect } from 'react'; // Add useState and useEffect
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPassword from "./pages/ForgotPassword";
import Offers from "./pages/Offers";
import Header from "./components/Header";
import { Bounce, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CreateListing from "./pages/CreateListing";
import Philanthropy from "./pages/Philanthropy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import ContactListingOwner from "./pages/ContactListingOwner";
import UploadDocuments from "./pages/UploadDocuments";
import Search from "./pages/Search";
import AddProfileImage from "./pages/AddProfileImage";
import BottomNavigation from "./components/BottomNavigation";
import UploadStatus from "./pages/UploadStatus";
import { StatusProvider } from "./utils/StatusContext";
import StatusPage from "./pages/StatusPage";
import FullStatusPage from "./pages/FullStatusPage";
import WelcomePage from "./pages/WelcomePage";
import { FollowProvider } from "./utils/FollowContext";
import TermsOfService from "./pages/TermsOfService";
import Users from "./pages/Users";
import Followers from "./pages/Followers";
import Following from "./pages/Following";
import Notifications from "./pages/Notifications";
import Messages from "./pages/Messages";
import Chat from "./pages/Chat";
import AweitBillboard from "./pages/AweitBillboard";
import UploadMusic from "./pages/UploadMusic";
import EditMusic from "./pages/EditMusic";
import Subscriptions from "./pages/Subscriptions";
import UploadListing from './pages/UploadListing';
import EditListing from './pages/EditListing';
import Categories from './pages/Categories';
import CategoryListings from './pages/CategoryListings';
import ListingPage from './pages/ListingPage';
import ListingImagesPage from './pages/ListingImagesPage';
import Trending from './pages/Trending';
import Pricing from "./pages/Pricing";

function App() {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true); // State for header visibility
  const [isNavVisible, setIsNavVisible] = useState(true); // State for bottom nav visibility
  const [lastScrollY, setLastScrollY] = useState(0); // Track last scroll position

  useEffect(() => {
  if (window.Paddle) {
    window.Paddle.Initialize({
      token: "YOUR_PADDLE_CLIENT_TOKEN"
    });

    console.log("Paddle initialized");
  }
}, []);

  // Handle scroll to show/hide header and bottom navigation
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        // Scrolling down (hide after scrolling past 50px to avoid flicker on small scrolls)
        setIsHeaderVisible(false);
        setIsNavVisible(false);
      } else {
        // Scrolling up
        setIsHeaderVisible(true);
        setIsNavVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <StatusProvider>
        <FollowProvider>
          <Router>
            <Header isVisible={isHeaderVisible} />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/profile" element={<PrivateRoute />}>
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/profile/:userId" element={<Profile />} />
                </Route>
                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/welcome" element={<WelcomePage />} />
                <Route path="/philanthropy" element={<Philanthropy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact-listing-owner" element={<ContactListingOwner />} />
                <Route path="/upload-documents" element={<UploadDocuments />} />
                <Route path="/listing/:id" element={<ListingPage />} />
                <Route path="/listing/:id/images" element={<ListingImagesPage />} />
                <Route path="/offers" element={<Offers />} />
                <Route path="/search" element={<Search />} />
                <Route path="/add-profile-image" element={<AddProfileImage />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/status" element={<StatusPage />} />
                <Route path="/status/:statusId" element={<StatusPage />} />
                <Route path="/status/:statusId/full" element={<FullStatusPage />} />
                <Route path="/users" element={<Users />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/aweit-billboard" element={<AweitBillboard />} />
                <Route path="/upload-music" element={<UploadMusic />} />
                <Route path="/edit-music/:musicId" element={<EditMusic />} />
                <Route path="/profile/:userId/followers" element={<Followers />} />
                <Route path="/profile/:userId/following" element={<Following />} />
                <Route path="/pricing" element={<Pricing />} />
                  <Route path="/trending" element={<Trending />} />
                 <Route path="/category/:category" element={<CategoryListings />} />
                <Route path="/upload-listing" element={<PrivateRoute />}>
                  <Route path="/upload-listing" element={<UploadListing />} />
                </Route>
                 <Route path="/edit-listing/:id" element={<PrivateRoute />}>
                  <Route path="/edit-listing/:id" element={<EditListing />} />
                </Route>
                <Route path="/upload-status" element={<PrivateRoute />}>
                  <Route path="/upload-status" element={<UploadStatus />} />
                </Route>
                <Route path="/create-listing" element={<PrivateRoute />}>
                  <Route path="/create-listing" element={<CreateListing />} />
                </Route>
                <Route path="/edit-listing" element={<PrivateRoute />}>
                  <Route path="/edit-listing/:chatId" element={<Chat />} />
                </Route>
                <Route path="/messages" element={<PrivateRoute />}>
                  <Route path="/messages" element={<Messages />} />
                </Route>
            </Routes>
            <BottomNavigation isVisible={isNavVisible} />
          </Router>
        </FollowProvider>
      </StatusProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </>
  );
}

export default App;